var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0332 3.6C5.53615 3.6 5.1332 4.00294 5.1332 4.5C5.1332 4.99706 5.53615 5.4 6.0332 5.4V3.6ZM6.0332 5.4H16.1665V3.6H6.0332V5.4ZM20.5999 9.83333V10.9H22.3999V9.83333H20.5999ZM16.1665 15.3333H6.0332V17.1333H16.1665V15.3333ZM20.5999 10.9C20.5999 13.3485 18.615 15.3333 16.1665 15.3333V17.1333C19.6091 17.1333 22.3999 14.3426 22.3999 10.9H20.5999ZM16.1665 5.4C18.615 5.4 20.5999 7.38487 20.5999 9.83333H22.3999C22.3999 6.39076 19.6091 3.6 16.1665 3.6V5.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.2333L9.7 12.5383L9.7 19.9284L2.5 16.2333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.ea92bd91766cffaa7abf998bf751ad85.svg";
export { ForwardRef as ReactComponent };